import React from "react";
import { useT } from "@/i18n";

/**
 * Compact pill-style language toggle showing FR + EN with circular flag SVGs.
 * Place anywhere — header, sidebar, etc.
 */
export default function LangToggle({ className = "", testid = "lang-toggle" }) {
  const { lang, setLang } = useT();
  return (
    <div
      data-testid={testid}
      className={`inline-flex items-center gap-1 border border-white/15 bg-black/40 backdrop-blur p-1 ${className}`}
      role="group"
      aria-label="Language switcher"
    >
      <button
        type="button"
        data-testid="lang-fr"
        aria-pressed={lang === "fr"}
        onClick={() => setLang("fr")}
        className={`relative inline-flex items-center gap-2 px-3 py-1.5 text-[11px] uppercase tracking-[0.22em] transition-colors ${
          lang === "fr" ? "bg-[#D4AF37] text-black" : "text-[#A1A1AA] hover:text-white"
        }`}
      >
        <FlagFR />
        <span>FR</span>
      </button>
      <button
        type="button"
        data-testid="lang-en"
        aria-pressed={lang === "en"}
        onClick={() => setLang("en")}
        className={`relative inline-flex items-center gap-2 px-3 py-1.5 text-[11px] uppercase tracking-[0.22em] transition-colors ${
          lang === "en" ? "bg-[#D4AF37] text-black" : "text-[#A1A1AA] hover:text-white"
        }`}
      >
        <FlagUS />
        <span>EN</span>
      </button>
    </div>
  );
}

const FlagFR = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" className="rounded-full overflow-visible">
    <defs>
      <clipPath id="circle-fr"><circle cx="8" cy="8" r="8" /></clipPath>
    </defs>
    <g clipPath="url(#circle-fr)">
      <rect x="0" y="0" width="5.33" height="16" fill="#0055A4" />
      <rect x="5.33" y="0" width="5.34" height="16" fill="#FFFFFF" />
      <rect x="10.67" y="0" width="5.33" height="16" fill="#EF4135" />
    </g>
  </svg>
);

const FlagUS = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" className="rounded-full overflow-visible">
    <defs>
      <clipPath id="circle-us"><circle cx="8" cy="8" r="8" /></clipPath>
    </defs>
    <g clipPath="url(#circle-us)">
      <rect x="0" y="0" width="16" height="16" fill="#FFFFFF" />
      {/* 7 red stripes */}
      {[0, 2.46, 4.92, 7.38, 9.84, 12.30, 14.76].map((y, i) => (
        <rect key={i} x="0" y={y} width="16" height="1.23" fill="#B22234" />
      ))}
      {/* Canton */}
      <rect x="0" y="0" width="7" height="7" fill="#3C3B6E" />
    </g>
  </svg>
);
